import styled from 'styled-components';

export const Container = styled.section`
  margin: 5px 25px;
  padding-bottom: 35px;
`;

export const ProjectsList = styled.div`
  height: 275px;
  display: flex;
  overflow-x: scroll;
`;
